import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Table from 'react-bootstrap/Table'

import axios from "axios";
import $ from 'jquery';
import tabler from './nlp/tabler_adl.js';
import frm from './formAux.js'
import './nlp/tabler.css';


function px(v) { return v+'px'; }
function pc(v) { if( v < 0 ) v = 0; if( v > 100 ) v = 100; return Math.round(v)+'%'; }
function val(v) { v = parseFloat(v); if( isNaN(v) ) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring( o ){ return typeof(o) == 'string';}
function isarray( o ){ return o instanceof Array;}
function isobj( o ){ return o instanceof Object;}
function isnumber( o ){ return typeof(o) == 'number' && !isNaN(o);}
function defined( o ){ return typeof(o) != 'undefined';}
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec(){	return new Date().getTime(); }
function getsec(){ return Math.round(getmsec()/1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig,'').toLowerCase() }
function iarray( v, n )
{
	var ret = [];
	for( var i = 0 ; i < n ; i++ )
	ret.push( v instanceof Object ? clone(v) : v );
	return ret;
}

function bool( s )
{
	if( typeof(s) == 'boolean' ) return s;
	if( !defined(s) || s === null ) return false;
	if( typeof(s) == 'number' ) return s > 0;
	if( s.match(/^y/i) ) return true;
	return false;
}

function sbool( v )
{
	return ['No','Yes'][v];
}

var companyList = [];
function getCompanies( callback )
{
	if( companyList.length ) callback( companyList )
	window.post( 'find_companies', {match:{active:true}}, function(res){
		if( res.status ) companyList = res.data.records;
		console.log( 'companyList', companyList );
		callback( companyList );
	})
}

var userClick = false;
function Users(prop) {

    var global = window.GlobalVars;
    var tab;

	function editUser( user, add )
	{
		console.log( 'USER', user );

		if( !add )
		{
			global.userSelected = user.email;
			window.saveSession();
			window.goPage('userSetup');
			return;
		}
		var origUser = clone(user);
		function showUser(user) {
			global.userSelected = user.email;
			window.saveSession();
			window.goPage('userSetup');
		}

		function required_fields(){
			$('#warnings').removeClass('hidden').addClass('block');
		}

	    function cb(ev)
	    {
			if( userClick ) {
				ev.preventDefault();
				ev.stopPropagation();
				return false;
			}
			userClick = true;

			let formError = false;

			$('.form-warning').hide();

			if( !user.name || !user.name.trim()){
				$('#warning-name').show();
				userClick = false;
				formError = true;
			}

			if( !user.email || !user.email.trim() || !frm.ckEmail(user.email)){
				$('#warning-email').show();
				userClick = false;
				formError = true;
			}

			if(formError) {
				return false;
			}

			var updateData = {
				_new: add || false,
				name: user.name,
				email: user.email,
				active: true,
				resetPassword: user.resetPassword,
			};
			window.post('update_user', { user: updateData }, function (res) {
				console.log('UPDATE USER', res, res.data._alreadyExists, res.data.status);
				if (res.data._alreadyExists) {
					return frm.myAlertClose( function(){
						frm.myAlert('User exists', 'This user is already registered. You may create roles for the existing user.', 'Ok', function () { showUser(user) });
						userClick = false;
					});
				} 
				else return showUser(user);
				// if (res.data.status) {
				// 	if( res.data._alreadyExists ) return frm.myAlert( 'User exists', 'This user is already registered. You may create roles for the existing user.', 'Ok', function(){ showUser(user) } );
				// 	return showUser(user);
				// }
				// else {
				// 	alert(res.data.value);
				// }
			});
			return false;
	    }
		if( Date.now() > user.resetTimeout ) user.resetPassword = null;
		var content = `
		<div id="userdetails">
		<label for="Email" class="email">Email *</label>
		<input placeholder="Email" type="email" id="email" class=" form-control email">
		<p class="hidden form-warning" id="warning-email" style="color:red">Email field is required</p>
		<label for="name">Name *</label>
		<input placeholder="Name" type="text" id="name" class=" form-control">
		<p class="hidden form-warning" id="warning-name" style="color:red">Name field is required</p>
		<label for="Temppassword">Temporary Password (optional)</label>
		<input placeholder="Temporary Password" type="password" id="resetPassword" class="mb-4 form-control">
		</div>
		`;

		function changed()
		{
		}

		function close()
		{

		}
		var btnName = add ? 'Add User' : 'Update User';
		var title = add ? 'Add New User' : 'User: ' + user.email;
		getCompanies( function(){
			frm.myAlert( title, content, btnName, cb, 'Cancel', close );
			if( !add )
			{
				$('#userdetails').find('.email').remove();
				var focus = $('#userdetails').find('#name')
			}
			else {
				var focus = $('#userdetails').find('.email')

			}
			if( window.hasPriv('admin') )
			{
				$('#company').append('<option value="" disabled selected hidden>Select Company</option>');
				$('#company').on('change', updatePrivs );
			}
			else user.company = companyList[0]._id;
			companyList.forEach( c => $('#company').append('<OPTION value="'+c._id+'">'+c.name+'</OPTION>') );


			setTimeout( function(){
				if( companyList.length == 1 ) $('#company').val(companyList[0]._id)
				focus.focus();
			}, 500);

			['email','name','company','resetPassword'].forEach( n =>
				{
					$('#userdetails').find('#'+n).val( user[n] ).on('change', function(){
						var id = $(this).prop('id');
						var val = $(this).val();
						console.log( 'change', id, val );
						user[id] = val;
						changed();
					})
				})

				// frm.booleanList( $('#userActive'), user)
				frm.booleanList( $('#userActive'), user, {
					items: {
						'active': { default: false, label: 'User Active' },
					},
					callbackOnInit: false,
				}, function(o){
					user.active = o.active;
					changed()
				});

				function updatePrivs()
				{
					var userPrivs = frm.arr2Bool(user.priv.split(','));
					var privItems = {};
					var cpriv = null;
					console.log( 'CLIST', companyList );
					if( !window.hasPriv('admin') )
					{
						cpriv = companyList.find( c => c._id == window.GlobalVars.userCompany );
						if( cpriv ) cpriv = cpriv.priv.split(',');
					}

					console.log( 'CPRIV', cpriv )
					for( var p in window.privs )
					{
						if( !cpriv || cpriv.indexOf(p) >= 0 ) privItems[p] = { default: false, label: window.privs[p] };
					}
					console.log( 'PPPPPPPPPPPPPPP', userPrivs, privItems );
					frm.booleanList( $('#userPrivs'), userPrivs, {
						items: privItems,
						header: ['','Privileges'],
						callbackOnInit: false,
					}, function(o){
						var npriv = [];
						for( var p in o ) if(o[p]) npriv.push(p);
						user.priv = npriv.join(',');
						// console.log( 'privs', o, user.priv );
						changed();
					} );
				}
				updatePrivs();
		});
	    return false;
	}





    useEffect( function(a){
		window.GlobalVars.userSelected = null;
        $('#topbuttons').html('');

		var addUserBut = $('<Button id="browseProjects" variant="primary" type="submit" class="mt-2 btn btn-primary"><i class="fa fa-plus mr-2"></i>Create User</Button>')
		addUserBut.on('click', () => {
			editUser( {active:true,priv:''}, 1 );
		})
		$('#topbuttons').append(addUserBut);

		var userSelect = window.GlobalVars.userProjectSelect == 1;
		if( userSelect )
		{
			var projBut = $('<Button id="browseProjects" variant="primary" type="submit" class="mt-2 ml-2 btn btn-secondary">Assign users to project<span class="selcount"></span></Button>')
			$('#topbuttons').append(projBut);
			projBut.on('click', function(){
				if( Object.keys(window.GlobalVars.userTableCtx.selected) == 0 )
				{
					// return frm.myAlert( '', 'Please select users to be added to the project' );
				}
				else
					window.GlobalVars.userProjectSelect = 2;
				window.saveSession();
				window.goPage('nlpWorkers');
			})
		}
		else {
			// window.GlobalVars.userTableCtx = {};
		}


        var match = {};
		window.post( 'find_users', {match:match}, function(res){
			console.log( 'users', res.data );
			var users = res.data.records;
			if( !users.length )
			{
				$('.alert').remove();
				var empty = $('<div role="alert" class="fade alert alert-danger show">').html('No documents found');
				$('#topbuttons').prepend(empty);
				$('#documentlist').hide();
			}
            var desc = {
				selectMode: userSelect,
				selectId: 'email',
                title: 'User Management',
                columns: {
	                // _id: 'Id',
                    name: 'Name',
                    email: 'Email',
					companyName: 'Company',
                    priv: 'Role',
					qualification:'Badges',
					// created: 'Created',
                    lastLogin: 'Last Login',
					active:'Active',
                },
                filter: true,
                search: true,
                sort: true,
                // sortAlias: { lastLoginDelta: 'lastLogin' },
                initialSort: 'lastLogin',
                initialSortDir: -1,
                pageSize: 10,
                // noFilter: ['lastLogin'],
                noSearch: null,
                noSort: null,
                centerCol: ['created','lastLogin','active'],
				format: tabler.formatString,
				formatCol: {
					lastLogin:tabler.formatTimeAgo,
					created:tabler.formatDate,
					// priv:tabler.formatPriv,
					priv:frm.smallerText,
					active: tabler.formatActive,
					qualification: frm.smallerText,
				},
				forceType:{ lastLogin: 1, active: 1, created: 1 },
				headerClick: 'filter',
                // clickCol: ['stateLabel','source'],
            }
            tab = tabler.table($('#documentlist'), desc, 'users' );
            users.forEach( a => {
                a.stateLabel = '<span class="state_'+a.state+'">' + a.stateLabel + '</span>';
				a.companyName = frm.aUnique(a.roles.map( r => r.companyName )).join(', ');
				// a.companyName = frm.aUnique(a.roles.map( r => r.companyName ).join(', '));
				var priv = {};
				a.roles.forEach( r => (r.priv || '').split(',').forEach( p => priv[p] = 1));
				a.priv = Object.keys(priv).map( p => tabler.formatPriv(p)).join('<br> ');
				a.qualification = a.qualification.join('<br> ')
                tab.addRow(a, function( col, row ){
                    console.log( 'tabler click', a._id, row[col], row )
					editUser( row );
                    // fileClickTabler( col, row )
                })
            });
            tab.draw();
			tab.saveCtx( selCount );
			selCount();
            console.log( 'desc', desc, 'tabler', tabler.formatString )
        });

    });

	function selCount()
	{
		var ctx = tabler.getCtx( 'users' );
		var s = ctx.selected || {};
		$('.selcount').text(' ('+Object.keys(s).length+')')
	}

    return (
        <div fluid="md p-0" className="maincontent">
        <div id="topbuttons"></div>
        <Table id="documentlist" bordered hover size="sm" className="table-grid mt-3">
        </Table>
        <span>&nbsp;</span>
        </div>
    )
}

export default Users
